<template>
    <div class="modal-dialog">

        <blue-circles/>

        <div class="modal-content">
            
            <form id="form-reset-pass-data-modal" v-on:submit.prevent="onSubmit" @submit="reset()">
                <div class="modal-body">
                    
                    <div class="reset-pass-container"> 
                        
                        <div class="login-logo">
                            <img src="vendors/images/logo-icon.png" alt="">
                        </div>

                        <h3>Redefinição de senha</h3>

                        <div class="form-group row">
                            <label class="col-sm-12">Nova Senha</label>
                            <div class="col-sm-12">
                                <input type="password" class="form-control" v-model="password" required>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-sm-12">Confirmar nova Senha</label>
                            <div class="col-sm-12">
                                <input type="password" class="form-control" v-model="confirmPassword" required>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-primary">
                            Salvar
                        </button>

                    </div>                  
                    
                </div>
                
            </form>

        </div>
    </div>

</template>

<script>

import { eventBus } from '../main';
import BlueCircles from "./BlueCircles.vue";
import authService from '../services/AuthService';

export default {
    name: 'ResetPass',
    components: {
        'blue-circles' : BlueCircles
    },
    data: () => ({
        reqId: "",
        password: "",
        confirmPassword: "",
        login: "",
    }),
    methods: {
        goToLogin(){
            this.$router.replace({'query': null});
            location.reload();
        },
        async reset(){

            if(this.password !== this.confirmPassword){
                eventBus.$emit('showWarnMessage', "Confirmação da nova senha está diferente.");
                return;
            }

            try {
                await authService.resetPassword(this.reqId, this.login, this.password);
                eventBus.$emit('showSuccessMessage', 'Senha redefinida com sucesso!', () => this.goToLogin());
            } catch(e){
                this.goToLogin();
            }

        },
        showModal(){
            const modalElm = document.getElementById('reset-pass-modal');
            modalElm.style.display = "block";
            modalElm.className += " show";
        },
        closeModal(){
            const modalElm = document.getElementById('reset-pass-modal');
            modalElm.style.display = "none";
            modalElm.className = modalElm.className.replace("show","");
        },
        onSubmit(){}
    },
    async mounted() {
        if(this.$route.query.resetPass){
            this.reqId = this.$route.query.reqId;
            this.login = this.$route.query.login;
            this.showModal();
        }
    }
}

</script>


<style scoped>

    .login-logo {
        padding-bottom: 15px;
        margin: 0 55px;
    }
   
    #reset-pass-modal .modal-dialog {
        max-width: 100%;
        max-height: 100%;
        overflow-y: hidden; 
        overflow-x: hidden;
    }

    #reset-pass-modal .modal-content {
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }  

    #reset-pass-modal .modal-body {
        z-index: 2;
    }

    .reset-pass-container {
        background: #FFFFFF;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
        border-radius: 16px;
        width: 494px;
        height: 570px;
        padding: 48px;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0.1px;
        color: #52575C;
        margin: 0 auto;
        z-index: 20;
    }

    .reset-pass-container a {
        color: #1086FF;
    }

    .reset-pass-container .btn {
        width: 100%;
        height: 61px;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 160%;
        color: #FFFFFF;
        background: #1040C6;
        margin-top: 40px;
    }

    .reset-pass-container h3 {
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
        letter-spacing: 0.1px;
        color: #161616;
        mix-blend-mode: normal;
        margin-top: 18px;
        margin-bottom: 36px;
        text-align: left;
    }

    .reset-pass-btn {
        color: #161616 !important;
    }

    .information-text {
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0.1px;
        color: #52575C;
        padding-bottom: 25px;
    }

</style>